import config from 'environment';
import { GadgetCommonModelGadgetTypeCodeEnum, GadgetEditModel } from 'types/entity';

export const getDefaultGadgetEditSizeAndName = (
  gadgetTypeCode: GadgetCommonModelGadgetTypeCodeEnum,
): Pick<GadgetEditModel, 'display_name_en' | 'display_name_ja' | 'width' | 'height' > => {
  /** 環境変数から取得する設定 */
  let setting: {
    display_name_ja?: string
    display_name_en?: string
    width?: string
    height?: string
  } = {};

  switch (gadgetTypeCode) {
    case GadgetCommonModelGadgetTypeCodeEnum.Gt1: {
      setting = config.gadgetSettings.mainMenu;
      break;
    }
    case GadgetCommonModelGadgetTypeCodeEnum.Gt3: {
      setting = config.gadgetSettings.downloadHistory;
      break;
    }
    case GadgetCommonModelGadgetTypeCodeEnum.Gt5: {
      setting = config.gadgetSettings.myShortcut;
      break;
    }
    case GadgetCommonModelGadgetTypeCodeEnum.Gt4: {
      setting = config.gadgetSettings.newArrival;
      break;
    }
    case GadgetCommonModelGadgetTypeCodeEnum.Gt2: {
      setting = config.gadgetSettings.searchCriteria;
      break;
    }
  }

  return {
    display_name_ja: setting?.display_name_ja || 'ガジェット',
    display_name_en: setting?.display_name_en || 'gadget',
    width: setting?.width ? parseInt(setting.width, 10) : 1,
    height: setting?.height ? parseInt(setting.height, 10) : 1,
  };
};
